import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import ReactSVG from 'react-svg';
import { connect } from 'react-redux';

import logoGray from '../../assets/images/logo-gray.png';
import facebook from '../../assets/images/soc_FB.svg';
import twitter from '../../assets/images/soc_twit.svg';
import googleplus from '../../assets/images/soc_google.svg';
import rss from '../../assets/images/soc_rss.svg';
import flickr from '../../assets/images/soc_flickr.svg';
import mail from '../../assets/images/soc_mail.svg';
import { Wrapper } from './style';

class Footer extends Component {
  render() {
    const { lang } = this.props;

    return (
      <Wrapper>
        <div className="root-container">
          <div className="container">
            <div className="logo-container">
              <img alt="Logo of OpenEdition" src={logoGray} />
            </div>

            <div className="description">
              <FormattedMessage id="footer.description" />
            </div>

            <div className="column-container">
              <div className="first-column column">
                <div>
                  <FormattedMessage id="footer.follow_us" />
                </div>
                <div className="icon-container">
                  <a
                    href="https://www.facebook.com/openedition"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <ReactSVG svgStyle={{ height: 29 }} src={facebook} />
                  </a>
                  <a
                    href="https://twitter.com/OpenEditionActu"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <ReactSVG svgStyle={{ height: 29 }} src={twitter} />
                  </a>
                  <a
                    href="https://plus.google.com/108610899365287453451"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <ReactSVG svgStyle={{ height: 29 }} src={googleplus} />
                  </a>
                  <a
                    href="https://www-openedition-org.wikipedialibrary.idm.oclc.org/backend"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <ReactSVG svgStyle={{ height: 29 }} src={rss} />
                  </a>
                  <a
                    href="https://www.flickr.com/photos/revuesorg"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <ReactSVG svgStyle={{ height: 29 }} src={flickr} />
                  </a>
                  <a href="mailto:contact@openedition.org">
                    <ReactSVG svgStyle={{ height: 29 }} src={mail} />
                  </a>
                </div>

                <a
                  className="abo-link"
                  href={`https://journals-openedition-org.wikipedialibrary.idm.oclc.org/?page=lettre&lang=${lang}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage id="footer.subscribe" />
                  <br />
                  <FormattedMessage id="footer.to_letter" />
                </a>
              </div>

              <div className="second-column column">
                <a
                  href={`https://www-openedition-org.wikipedialibrary.idm.oclc.org/11932?lang=${lang}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage id="footer.cgu" />
                </a>
                <a
                  href={`https://www-openedition-org.wikipedialibrary.idm.oclc.org/11893?lang=${lang}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage id="footer.credits" />
                </a>
                <a
                  href={`https://www-openedition-org.wikipedialibrary.idm.oclc.org/19362?lang=${lang}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage id="footer.terms" />
                </a>
                {/*<a href="#" target="_blank" rel="noopener noreferrer">
                <FormattedMessage id="footer.access" />
              </a>*/}
              </div>
            </div>
          </div>
        </div>
      </Wrapper>
    );
  }
}

export default connect(
  ({ ui: { lang } }) => ({
    lang
  }),
  () => ({})
)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/index.js